import { Component, OnInit } from '@angular/core';
import { HttpClient} from "@angular/common/http";
import { Observable, of } from "rxjs";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
    ngOnInit() {
    }
    public edited_apache = false;
    public edited_nginx = false;
    public apache_copied = false;
    public nginx_copied = false;
    selectedFile: File = null;
    apache_text = '';
    nginx_text = '';
    apache_area_text = '';
    nginx_area_text = '';
    title = 'fileupload';
    timer: any;

    private dom: Document;


    constructor(private http: HttpClient){}

    returnApacheText() {
        return of(this.apache_text);
    }
    returnNginxText() {
        return of(this.nginx_text);
    }

    private setting = {
        element: {
            dynamicDownload: null as HTMLElement
        }
    }

    onFileSelected(event){
        this.selectedFile = event.target.files[0];
        this.edited_apache = false;
        this.edited_nginx = false;
        this.nginx_area_text = "";
        this.apache_area_text = "";
    }
    onUpload(){
        const fd = new FormData();
        if (this.selectedFile != null) {
            fd.append('file', this.selectedFile, this.selectedFile.name);
            this.apache_text = '';
            this.nginx_text = '';
            this.apache_area_text = '';
            this.nginx_area_text = '';
            let fileReader = new FileReader();
            fileReader.onload = (e) => {
                var csv_text = "";
                if (ext == "csv") {
                    csv_text = (<string>fileReader.result);
                }
                else {
                    var data = fileReader.result;
                    var workbook = XLSX.read(data, {
                        type: 'binary'
                    });

                    workbook.SheetNames.forEach(function (sheetName) {
                        // Here is your object
                        var XL_row_object = XLSX.utils.sheet_to_csv(workbook.Sheets[sheetName], {FS: ";"});
                        //var json_object = JSON.stringify(XL_row_object);
                        csv_text = XL_row_object;
                    })
                }

                var rows = csv_text.split("\r\n");
                if (rows.length == 1) {
                    rows = csv_text.split("\n");
                }
                this.apache_text += '<IfModule mod_headers.c><br>';

                for (var i = 0; i < rows.length; i++) {
                    var cells = rows[i].split(";");

                    for (var j = 0; j < cells.length; j++) {
                        if (cells.length == 2) {
                            var pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
                            if (pattern.test(cells[0])) {
                                var first_url = new URL(cells[0]);
                                cells[0] = first_url.pathname;
                            }

                            this.apache_text += '<Files ~*' + cells[0] + '><br>';
                            this.apache_text += 'Header append Link "<' + cells[1] + '>; rel=\"canonical\""<br>';
                            this.apache_text += '</Files><br>'

                            cells[0] = cells[0].replace('\.', '\\.');
                            this.nginx_text += 'location ~*' + cells[0] + '$ {<br>';
                            var url = new URL(cells[1]);
                            var pathname = url.pathname;
                            this.nginx_text += '        add_header Link "<$scheme://$http_host' + pathname + '>; rel=\"canonical\"";<br>';
                            this.nginx_text += '    }<br>';

                            j++;
                        }
                    }
                }
                this.apache_text += '</IfModule>';

                this.apache_area_text = this.apache_text.replace(/\\"</g, '"<');
                this.nginx_area_text = this.nginx_text.replace(/\\"</g, '"<');
                this.nginx_area_text = this.nginx_area_text.replace(/\\"\\";/g, '\\"";');
                this.apache_area_text = this.apache_area_text.replace(/\\"\\"/g, '\""');

                this.apache_area_text = this.apache_area_text.replace(/\\\\./g, '\\.');
                this.apache_area_text = this.apache_area_text.replace(/<br>/g, "\r\n");

                this.nginx_area_text = this.nginx_area_text.replace(/\\\\./g, '\\.');
                this.nginx_area_text = this.nginx_area_text.replace(/<br>/g, "\r\n");

                this.edited_apache = true;
                this.edited_nginx = true;
            }

            var re = /(?:\.([^.]+))?$/;

            var ext = re.exec(this.selectedFile.name)[1];
            if (ext == "csv" || ext == "xlsx" || ext == "xls") {
                if (ext == "csv") {
                    fileReader.readAsText(this.selectedFile);
                }
                else {
                    fileReader.readAsBinaryString(this.selectedFile);
                }
            }
            else {
                alert('Wrong file format, only "csv" or "xlsx" or "xls" file formats.');
            }
        }
        return false;
    }

    dynamicDownloadApache() {
        this.returnApacheText().subscribe((res) => {
            this.dyanmicDownloadByHtmlTag({
                fileName: ' .htaccess',
                text: JSON.stringify(res)
            });
        });
        return false;
    }

    dynamicDownloadNginx() {
        this.returnNginxText().subscribe((res) => {
            this.dyanmicDownloadByHtmlTag({
                fileName: '_nginx.conf',
                text: JSON.stringify(res)
            });
        });
        return false;
    }

    private dyanmicDownloadByHtmlTag(arg: {
        fileName: string,
        text: string
    }) {
        if (!this.setting.element.dynamicDownload) {
            this.setting.element.dynamicDownload = document.createElement('a');
        }
        const element = this.setting.element.dynamicDownload;
        const fileType = arg.fileName.indexOf('.htaccess') > -1 ? '.htaccess' : 'conf';
        arg.text = arg.text.replace(/\\"</g, '"<');
        if (fileType == "conf") {
            arg.text = arg.text.replace(/\\"\\";/g, '\\"";');
        }
        else {
            arg.text = arg.text.replace(/\\"\\"/g, '\""');
        }
        arg.text = arg.text.replace(/\\\\./g, '\\.');
        arg.text = arg.text.substr(1);
        arg.text = arg.text.substring(0, arg.text.length - 1);

        arg.text = arg.text.replace(/<br>/g, encodeURIComponent("\r\n"));

        element.setAttribute('href', `data:${fileType};charset=utf-8,${arg.text}`);
        element.setAttribute('download', arg.fileName);
        var event = new MouseEvent("click");
        element.dispatchEvent(event);
    }

    public copyApacheToClipboard(){
        const inputElement = document.getElementById('apacheOutput');
        (<any>inputElement).select();
        document.execCommand('copy');
        inputElement.blur();
        this.apache_copied = true;
        this.timer = setTimeout(() => {
            this.apache_copied = false;
        }, 600);
        return false;
    }

    public copyNginxToClipboard() {
        const inputElement = document.getElementById('nginxOutput');
        (<any>inputElement).select();
        document.execCommand('copy');
        inputElement.blur();
        this.nginx_copied = true;
        this.timer = setTimeout(() => {
            this.nginx_copied = false;
        }, 600);
        return false;
    }
}
